Blocker = require './Blocker'
classnames = require 'classnames'
ConfirmationModal = require '../../../a2i/js/components/ConfirmationModal'
FeedbackButton = require './FeedbackButton'
immutable = require 'seamless-immutable'
InnerGlyphicon = require './InnerGlyphicon'
moment = require 'moment'
ObservationHeader = require './ObservationHeader'
React = require 'react'
ReactTooltip = require 'react-tooltip'
require '../../styles/ObserveTeacher'
require 'moment-duration-format'
TimesUpModal = require './TimesUpModal'
{ Button, ButtonGroup, DropdownButton, Glyphicon, MenuItem, Modal } = require 'react-bootstrap'
{ Component, PropTypes } = React

{
	CONTEXT_IDS: {
		WHOLE_CLASS
		SMALL_GROUP
		INDIV
	}
	GRADE_LEVEL_IDS: {
		KINDERGARTEN
		PRE_K
	}
	MANAGEMENT_IDS: {
		TEACHER
		PEERS
		ALONE
	}
	INSTRUCTION_TYPE_IDS: {
		MEANING_FOCUSED
		CODE_FOCUSED
		PLAY
		NUMBER_OPERATIONS
		ALGEBRA
		GEOMETRY
		APPLIED
		OPERATIONS
	}
	OBSERVATION_SUBJECT_IDS: {
		NON_INSTRUCTION
		ART
		LITERACY
		MATH
		MUSIC
		OTHER
		SCIENCE
		SOCIAL_STUDIES
		MEAL_TIME
		SOCIOEMOTIONAL_LEARNING
		OFF_CAMERA
	}
} = require '../lib/commonIds'


class ObserveTeacherComponent extends Component
	@propTypes:
		askDone: PropTypes.func.isRequired
		cancelDone: PropTypes.func.isRequired
		confirmingDone: PropTypes.bool.isRequired
		createTeacherObservation: PropTypes.func.isRequired
		createTeacherObservationEvent: PropTypes.func.isRequired
		currentCycleNumber: PropTypes.number.isRequired
		done: PropTypes.func.isRequired
		endTeacherObservation: PropTypes.func.isRequired
		gradeLevelId: PropTypes.number.isRequired
		handleUndo: PropTypes.func.isRequired
		isTimerRunning: PropTypes.bool.isRequired
		isTimerUp: PropTypes.bool.isRequired
		navigationWarningModal: PropTypes.node
		numberOfCycles: PropTypes.number.isRequired
		observation: PropTypes.object.isRequired
		teacher: PropTypes.object.isRequired
		teacherMinutes: PropTypes.object.isRequired
		timer: PropTypes.string.isRequired
		toggleTimer: PropTypes.func.isRequired

	state:
		eventIdsBeingAnimated:
			# These are the teacher_event_type IDs from the database.
			1: false
			2: false
			3: false
			4: false
			5: false
			6: false
			7: false
			8: false
			9: false
			10: false
			11: false
			12: false
			13: false

	componentWillMount: ->
		mostRecentTeacherObservation = @getMostRecentTeacherObservation()

		if mostRecentTeacherObservation == null || !!mostRecentTeacherObservation.ended_at
			@createTeacherObservation()

	componentWillUnmount: ->
		@props.endTeacherObservation()

	componentDidUpdate: ->
		ReactTooltip.rebuild()

	getMostRecentTeacherObservation: ->
		if @props.observation.teacher_observations?.length
			return _.last(@props.observation.teacher_observations)
		else
			return null

	createTeacherObservation: (updatedKey = null, value = null) ->
		mostRecentObservation = @getMostRecentTeacherObservation()

		if (mostRecentObservation)
			observationData = {
				observation_subject_id: mostRecentObservation.observation_subject_id,
				observation_context_id: mostRecentObservation.observation_context_id,
				observation_instruction_type_id: mostRecentObservation.observation_instruction_type_id,
				started_at: moment.utc().format('YYYY-MM-DD HH:mm:ss'),
				observation_management_id: mostRecentObservation.observation_management_id,
				cycle_number: @props.currentCycleNumber,
				time_on_clock: @props.timer
			}
		else
			observationData = {
				observation_subject_id: NON_INSTRUCTION,
				observation_context_id: WHOLE_CLASS,
				observation_instruction_type_id: MEANING_FOCUSED,
				started_at: moment.utc().format('YYYY-MM-DD HH:mm:ss'),
				observation_management_id: TEACHER,
				cycle_number: @props.currentCycleNumber,
				time_on_clock: @props.timer
			}

		if updatedKey != null
			observationData[updatedKey] = value

			switch updatedKey
				when 'observation_management_id'
					if value == PEERS
						observationData.observation_context_id = SMALL_GROUP
					else if value == ALONE
						observationData.observation_context_id = INDIV
				when 'observation_subject_id'
					if value == LITERACY
						observationData.observation_instruction_type_id = CODE_FOCUSED
					else if value == MATH
						observationData.observation_instruction_type_id = NUMBER_OPERATIONS
					else
						observationData.observation_instruction_type_id = null

						if value == NON_INSTRUCTION
							observationData.observation_management_id = TEACHER

		@props.createTeacherObservation(observationData)

	createTeacherObservationEvent: (eventId) ->
		# Record the event
		@props.createTeacherObservationEvent(eventId)

		# Give the user some animated feedback to indicate that the click ws received
		{ eventIdsBeingAnimated } = @state
		eventIdsBeingAnimated[eventId] = true;
		@setState({ eventIdsBeingAnimated })

		setTimeout =>
			{ eventIdsBeingAnimated } = @state
			eventIdsBeingAnimated[eventId] = true;
			@setState({ eventIdsBeingAnimated })
		, 750

	isDisabledContext: (contextId) ->
		teacherObservation = @getMostRecentTeacherObservation()
		if teacherObservation?.observation_management_id == PEERS && teacherObservation?.observation_context_id != SMALL_GROUP
			return true
		else if teacherObservation?.observation_management_id == ALONE && teacherObservation?.observation_context_id != INDIV
			return true
		else
			return false

	isDisabledManagement: (managementId) ->
		teacherObservation = @getMostRecentTeacherObservation()
		teacherObservation?.observation_subject_id == NON_INSTRUCTION

	handleEndEarly: =>
		@createTeacherObservationEvent(17)
		@props.done()

	getEventTypeButtons: =>
		buttonGroups = {
			danger: [
				{ id: 1, description: 'Invites students to share information' },
				{ id: 2, description: "Summarizes or synthesizes students’ responses" },
				{ id: 3, description: "Expresses interest in students’ responses" }
			],
			warning: [
				{ id: 4, description: 'Explains topic-specific concepts' },
				{ id: 5, description: 'Provides background information with facts or informative content' }
			],
			success: [
				{ id: 6, description: "Directs students to use evidence and explanation to support answers" },
				{ id: 8, description: "Challenges students to reason or draw conclusions" },
				{ id: 7, description: "Asks follow-up questions to gain additional information or clarify an idea" },
				{ id: 9, description: "Encouraging students to make connections to self or other text or problem" }
			],
			primary: [
				{ id: 10, description: "Handles disruptions quickly and efficiently" },
				{ id: 11, description: "Redirects student misbehavior in positive way" },
				{ id: 12, description: "Uses a positive behavior management strategy" },
				{ id: 13, description: "Smooth and orderly transition between classroom activities" }
			]
		}
		buttons = []
		Object.keys(buttonGroups).map (buttonType) =>
			buttonGroup = buttonGroups[buttonType]

			buttons.push (
				React.createElement("div", {"className": "moves-buttons", "key": ( "btn-group-" + buttonType )},
					(
						buttonGroup.map (eventType) =>
							React.createElement(FeedbackButton, { \
								"key": ( eventType.id ),  \
								"className": ( "btn btn-" + buttonType ),  \
								"onClick": ( => @createTeacherObservationEvent(eventType.id) ),  \
								"innerHTML": ( eventType.description )
							})
					)
				)
			)
		return buttons

	render: =>
		{ eventIdsBeingAnimated } = @state
		teacherObservation = @getMostRecentTeacherObservation()

		subjectTitle = switch teacherObservation?.observation_subject_id
			when ART then 'Art'
			when SCIENCE then 'Science'
			when SOCIAL_STUDIES then 'Soc. Studies'
			when MUSIC then 'Music'
			when MEAL_TIME then 'Meal'
			when SOCIOEMOTIONAL_LEARNING then 'SEL'
			when OFF_CAMERA then 'Off Cam'
			else 'Other'

		React.createElement("div", {"className": "observe-teacher-container"},
			React.createElement(ReactTooltip, {"delayShow": ( 700 )}),
			React.createElement(ObservationHeader, { \
				"confirmDone": ( @props.askDone ),  \
				"currentCycleNumber": ( @props.currentCycleNumber ),  \
				"handleUndo": ( @props.handleUndo ),  \
				"isTimerRunning": ( @props.isTimerRunning ),  \
				"numberOfCycles": ( @props.numberOfCycles ),  \
				"timer": ( @props.timer ),  \
				"toggleTimer": ( @props.toggleTimer ),  \
				"totalTime": ( @props.teacherMinutes.format('hh:mm:ss', trim: false) )
			}),

			React.createElement("div", {"className": "observe-card observe-teacher"},
				React.createElement(Blocker, {"shouldShow": ( !@props.isTimerRunning )}),
				React.createElement("div", {"className": "toggle-list"},
					React.createElement("div", {"className": "name"}, ( @props.teacher.first_name ), " ", ( @props.teacher.last_name )),
					React.createElement("div", {"className": "subjects"},
						React.createElement("h4", {"className": "observation-heading"}, "Content Area"),
						React.createElement(ButtonGroup, {"className": "btn-grouping"},
							React.createElement(ButtonGroup, null,
								React.createElement(Button, { \
									"className": ( classnames { selected: teacherObservation?.observation_subject_id == LITERACY } ),  \
									"onClick": ( => @createTeacherObservation('observation_subject_id', LITERACY) )
								}, """
\t\t\t\t\t\t\t\t\tLiteracy
""")
							),
							React.createElement(ButtonGroup, null,
								React.createElement(Button, { \
									"className": ( classnames { selected: teacherObservation?.observation_subject_id == MATH } ),  \
									"onClick": ( => @createTeacherObservation('observation_subject_id', MATH) )
								}, """
\t\t\t\t\t\t\t\t\tMath
""")
							),
							React.createElement(DropdownButton, { \
								"title": ( subjectTitle ),  \
								"className": (
									classnames({
										selected: [
											ART,
											SCIENCE,
											SOCIAL_STUDIES,
											MUSIC,
											OTHER,
											MEAL_TIME,
											SOCIOEMOTIONAL_LEARNING,
											OFF_CAMERA
										].includes(teacherObservation?.observation_subject_id)
									})
								),  \
								"id": ( @props.teacher.first_name + '-' + @props.teacher.last_name + '-subject-dropdown' )
							},
								React.createElement(MenuItem, { \
									"eventKey": ( String(ART) ),  \
									"active": ( teacherObservation?.observation_subject_id == ART ),  \
									"onClick": ( => @createTeacherObservation('observation_subject_id', ART) )
								}, """
\t\t\t\t\t\t\t\t\tArt
"""),
								React.createElement(MenuItem, { \
									"eventKey": ( String(SCIENCE) ),  \
									"active": ( teacherObservation?.observation_subject_id == SCIENCE ),  \
									"onClick": ( => @createTeacherObservation('observation_subject_id', SCIENCE) )
								}, """
\t\t\t\t\t\t\t\t\tScience
"""),
								React.createElement(MenuItem, { \
									"eventKey": ( String(SOCIAL_STUDIES) ),  \
									"active": ( teacherObservation?.observation_subject_id == SOCIAL_STUDIES ),  \
									"onClick": ( => @createTeacherObservation('observation_subject_id', SOCIAL_STUDIES) )
								}, """
\t\t\t\t\t\t\t\t\tSocial Studies
"""),
								React.createElement(MenuItem, { \
									"eventKey": ( String(MUSIC) ),  \
									"active": ( teacherObservation?.observation_subject_id == MUSIC ),  \
									"onClick": ( => @createTeacherObservation('observation_subject_id', MUSIC) )
								}, """
\t\t\t\t\t\t\t\t\tMusic
"""),
								React.createElement(MenuItem, { \
									"eventKey": ( String(MEAL_TIME) ),  \
									"active": ( teacherObservation?.observation_subject_id == MEAL_TIME ),  \
									"onClick": ( => @createTeacherObservation('observation_subject_id', MEAL_TIME) )
								}, """
\t\t\t\t\t\t\t\t\tMeal Time
"""),
								React.createElement(MenuItem, { \
									"eventKey": ( String(SOCIOEMOTIONAL_LEARNING) ),  \
									"active": ( teacherObservation?.observation_subject_id == SOCIOEMOTIONAL_LEARNING ),  \
									"onClick": ( => @createTeacherObservation('observation_subject_id', SOCIOEMOTIONAL_LEARNING) )
								}, """
\t\t\t\t\t\t\t\t\tSocioemotional Learning
"""),
								React.createElement(MenuItem, { \
									"eventKey": ( String(OFF_CAMERA) ),  \
									"active": ( teacherObservation?.observation_subject_id == OFF_CAMERA ),  \
									"onClick": ( => @createTeacherObservation('observation_subject_id', OFF_CAMERA) )
								}, """
\t\t\t\t\t\t\t\t\tOff Camera
"""),
								React.createElement(MenuItem, { \
									"eventKey": ( String(OTHER) ),  \
									"active": ( teacherObservation?.observation_subject_id == OTHER ),  \
									"onClick": ( => @createTeacherObservation('observation_subject_id', OTHER) )
								}, """
\t\t\t\t\t\t\t\t\tOther
""")
							),
							React.createElement(ButtonGroup, null,
								React.createElement(Button, { \
									"className": ( classnames { selected: teacherObservation?.observation_subject_id == NON_INSTRUCTION } ),  \
									"onClick": ( => @createTeacherObservation('observation_subject_id', NON_INSTRUCTION) ),  \
									"data-tip": "Non-instruction"
								}, """
\t\t\t\t\t\t\t\t\tNon-Inst
""")
							)
						)
					),
					React.createElement("div", {"className": "grouping"},
						React.createElement("h4", {"className": "observation-heading"}, "Context"),
						React.createElement(ButtonGroup, {"className": "btn-grouping"},
						 React.createElement(ButtonGroup, null,
						 	React.createElement(Button, { \
						 		"disabled": ( @isDisabledContext(WHOLE_CLASS) ),  \
						 		"className": ( classnames { selected: teacherObservation?.observation_context_id == WHOLE_CLASS } ),  \
						 		"onClick": ( => @createTeacherObservation('observation_context_id', WHOLE_CLASS) ),  \
						 		"data-tip": "Whole class"
						 	}, """
\t\t\t\t\t\t \t\tWC
""")
						 ),
						 React.createElement(ButtonGroup, null,
						 	React.createElement(Button, { \
						 		"disabled": ( @isDisabledContext(SMALL_GROUP) ),  \
						 		"className": ( classnames { selected: teacherObservation?.observation_context_id == SMALL_GROUP } ),  \
						 		"onClick": ( => @createTeacherObservation('observation_context_id', SMALL_GROUP) ),  \
						 		"data-tip": "Small group"
						 	}, """
\t\t\t\t\t\t \t\tSmG
""")
						 ),
						 React.createElement(ButtonGroup, null,
						 	React.createElement(Button, { \
						 		"disabled": ( @isDisabledContext(INDIV) ),  \
						 		"className": ( classnames { selected: teacherObservation?.observation_context_id == INDIV } ),  \
						 		"onClick": ( => @createTeacherObservation('observation_context_id', INDIV) ),  \
						 		"data-tip": "Individual"
						 	}, """
\t\t\t\t\t\t \t\tIndiv
""")
						 )
						),
						React.createElement(ButtonGroup, {"className": "btn-grouping"},
							React.createElement(ButtonGroup, null,
								React.createElement(Button, { \
									"className": ( classnames { selected: teacherObservation?.observation_management_id == TEACHER } ),  \
									"onClick": ( => @createTeacherObservation('observation_management_id', TEACHER) )
								}, """
\t\t\t\t\t\t\t\t\tTeacher
""")
							),
							React.createElement(ButtonGroup, null,
								React.createElement(Button, { \
									"disabled": ( @isDisabledManagement(PEERS) ),  \
									"className": ( classnames { selected: teacherObservation?.observation_management_id == PEERS } ),  \
									"onClick": ( => @createTeacherObservation('observation_management_id', PEERS) )
								}, """
\t\t\t\t\t\t\t\t\tPeers
""")
							),
							React.createElement(ButtonGroup, null,
								React.createElement(Button, { \
									"disabled": ( @isDisabledManagement(ALONE) ),  \
									"className": ( classnames { selected: teacherObservation?.observation_management_id == ALONE } ),  \
									"onClick": ( => @createTeacherObservation('observation_management_id', ALONE) )
								}, """
\t\t\t\t\t\t\t\t\tAlone
""")
							)
						)
					),
					React.createElement("div", {"className": ( classnames 'instruction-types': true, 'visibility-hidden': ![LITERACY, MATH].includes(teacherObservation?.observation_subject_id) )},
						React.createElement("h4", {"className": "observation-heading"}, "Instruction Type"),
						(
							if teacherObservation?.observation_subject_id == MATH
								React.createElement(ButtonGroup, {"className": "btn-grouping"},
									React.createElement(ButtonGroup, null,
										React.createElement(Button, { \
											"className": ( classnames { selected: teacherObservation?.observation_instruction_type_id == NUMBER_OPERATIONS } ),  \
											"onClick": ( => @createTeacherObservation('observation_instruction_type_id', NUMBER_OPERATIONS) ),  \
											"data-tip": "Numbers"
										}, """
\t\t\t\t\t\t\t\t\t\t\tNu
""")
									),
									React.createElement(ButtonGroup, null,
										React.createElement(Button, { \
											"className": ( classnames { selected: teacherObservation?.observation_instruction_type_id == OPERATIONS } ),  \
											"onClick": ( => @createTeacherObservation('observation_instruction_type_id', OPERATIONS) ),  \
											"data-tip": "Operations"
										}, """
\t\t\t\t\t\t\t\t\t\t\tOp
""")
									),
									React.createElement(ButtonGroup, null,
										React.createElement(Button, { \
											"className": ( classnames { selected: teacherObservation?.observation_instruction_type_id == ALGEBRA } ),  \
											"onClick": ( => @createTeacherObservation('observation_instruction_type_id', ALGEBRA) ),  \
											"data-tip": "Algebra"
										}, """
\t\t\t\t\t\t\t\t\t\t\tAl
""")
									),
									React.createElement(ButtonGroup, null,
										React.createElement(Button, { \
											"className": ( classnames { selected: teacherObservation?.observation_instruction_type_id == GEOMETRY } ),  \
											"onClick": ( => @createTeacherObservation('observation_instruction_type_id', GEOMETRY) ),  \
											"data-tip": "Geometry"
										}, """
\t\t\t\t\t\t\t\t\t\t\tGo
""")
									),
									React.createElement(ButtonGroup, null,
										React.createElement(Button, { \
											"className": ( classnames { selected: teacherObservation?.observation_instruction_type_id == APPLIED } ),  \
											"onClick": ( => @createTeacherObservation('observation_instruction_type_id', APPLIED) ),  \
											"data-tip": "Applied"
										}, """
\t\t\t\t\t\t\t\t\t\t\tAp
""")
									)
								)
							else
								React.createElement(ButtonGroup, {"className": "btn-grouping"},
									React.createElement(ButtonGroup, null,
										React.createElement(Button, { \
											"className": ( classnames { selected: teacherObservation?.observation_instruction_type_id == CODE_FOCUSED } ),  \
											"onClick": ( => @createTeacherObservation('observation_instruction_type_id', CODE_FOCUSED) ),  \
											"data-tip": "Code-focused"
										}, """
\t\t\t\t\t\t\t\t\t\t\tCF
""")
									),
									React.createElement(ButtonGroup, null,
										React.createElement(Button, { \
											"className": ( classnames { selected: teacherObservation?.observation_instruction_type_id == MEANING_FOCUSED } ),  \
											"onClick": ( => @createTeacherObservation('observation_instruction_type_id', MEANING_FOCUSED) ),  \
											"data-tip": "Meaning-focused"
										}, """
\t\t\t\t\t\t\t\t\t\t\tMF
""")
									),
									(
										if (@props.gradeLevelId == KINDERGARTEN || @props.gradeLevelId == PRE_K) && teacherObservation?.observation_subject_id == LITERACY
											React.createElement(ButtonGroup, null,
												React.createElement(Button, { \
													"className": ( classnames { selected: teacherObservation?.observation_instruction_type_id == PLAY } ),  \
													"onClick": ( => @createTeacherObservation('observation_instruction_type_id', PLAY) )
												}, """
\t\t\t\t\t\t\t\t\t\t\t\t\tPlay
""")
											)
									)
								)
						)
					)
				),
				React.createElement("div", {"className": "events"},
					React.createElement("h4", {"className": "observation-heading"}, "Moves"),
					( @getEventTypeButtons() )
				)
			),
			React.createElement(ConfirmationModal, { \
				"body": "Are you sure you're done with this observation?",  \
				"confirmationButtonStyle": "warning",  \
				"confirmationButtonText": "Yes, done",  \
				"onCancel": ( @props.cancelDone ),  \
				"onConfirm": ( @handleEndEarly ),  \
				"shouldShow": ( @props.confirmingDone ),  \
				"title": "Really done?"
			}),
			React.createElement(TimesUpModal, {"onClose": ( @props.done ), "shouldShow": ( @props.isTimerUp )}),
			( @props.navigationWarningModal )
		)

module.exports = ObserveTeacherComponent



// WEBPACK FOOTER //
// ./~/cjsx-loader!./frontend/olos/js/components/ObserveTeacher.cjsx